module.exports = __webpack_public_path__ + "img/我的访客.a5cf8656.svg";